<template>
  <div>
    <el-dialog
      title="退款"
      :visible.sync="refundShow"
      :append-to-body="true"
      width="60%"
      @open="open"
    >
      <div>
        <div class="margin-bottom-15 font-light font-16">物品信息</div>
        <goodsInfo :expressOrderDetails="refundDetail.expressOrderDetails" />
        <div class="margin-y-15 font-light font-16">支付信息</div>
        <el-descriptions
          direction="vertical"
          :column="8"
          border
          size="small"
          labelStyle="text-align: center;"
          contentStyle="text-align: center;"
        >
          <el-descriptions-item label="状态">
            <template slot="label">
              <el-checkbox disabled />
            </template>
            <el-checkbox v-model="form.isPick" />
          </el-descriptions-item>
          <el-descriptions-item label="状态">{{ refundDetail.payStatusStr }}</el-descriptions-item>
          <el-descriptions-item label="退款类型">
            <div class="flex flex-col flex-align-start">
              <el-radio v-model="form.refundType" :label="1" size="mini">退款退单</el-radio>
              <el-radio
                v-model="form.refundType"
                @change="onlyRefund"
                :label="2"
                size="mini"
                class="margin-top-5"
                >仅退款</el-radio
              >
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="支付金额">{{ refundDetail.payAmount }}</el-descriptions-item>
          <el-descriptions-item label="已扣退款违约金">{{
            refundDetail.refundServiceChargeAmount
          }}</el-descriptions-item>
          <el-descriptions-item label="已扣改签违约金">{{
            refundDetail.changeServiceChargeAmount
          }}</el-descriptions-item>
          <el-descriptions-item label="已扣金额">{{
            refundDetail.refundAmount
          }}</el-descriptions-item>
          <el-descriptions-item label="剩余可退金额">
            <template>
              <el-input-number
                size="small"
                v-model="form.refundAmount"
                controls-position="right"
                :min="0"
                :max="refundDetail.payAmount - refundDetail.refundAmount"
                :precision="2"
                style="width: 7vw"
                :controls="false"
              />
            </template>
          </el-descriptions-item>
        </el-descriptions>

        <div class="margin-y-15 font-light font-16 required position-relative">退款原因</div>
        <el-input
          type="textarea"
          v-model="form.remark"
          placeholder="请说明退款的原因"
          :rows="4"
          maxlength="100"
          show-word-limit
        />
      </div>
      <div style="display: flex; font-size: 13px; color: #9f9f9f; margin-left: 10px">
        <div>注：</div>
        <div>
          <div>退票退款，表示退款的同时退订单</div>
          <div>仅退款，表示该操作仅退款不退订单，寄件人可正常寄件</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="danger" @click="cancel">取 消</el-button>
        <el-button :disabled="isDisabled" type="primary" size="small" @click="submit"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script >
import { inject, ref } from '@vue/composition-api';
import goodsInfo from './goods-info.vue';
import { MessageBox, Message } from 'element-ui';
import { refundApply } from '@/api/express/order';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const refundDetail = inject('refundDetail');
  const refundShow = inject('refundShow');
  const form = ref({
    refundType: 1,
    refundAmount: 0,
    isPick: false,
    remark: ''
  });
  const open = () => {
    form.value.refundAmount = refundDetail.value.surplusAmount;
  };
  const onlyRefund = () => {
    MessageBox.confirm('仅退款表示本次操作仅退款不退订单，寄件人仍可正常寄件！', '确定仅退款吗？', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {}).catch(() => {
      form.value.refundType = 1;
      Message({
        type: 'info',
        message: '已取消'
      });
    });
  };
  const submit = async () => {
    const {
      isPick,
      remark,
      refundAmount,
      refundType
    } = form.value;
    if (!isPick) {
      Message.warning('请勾选支付信息！');
      return;
    }
    if (!remark) {
      Message.warning('请填写退款原因！');
      return;
    }
    const params = {
      refundType,
      refundAmount,
      remark,
      orderId: refundDetail.value.orderId
    };
    const {
      code
    } = await refundApply(params);
    if (code === 0) {
      Message.success('操作成功！');
      cancel();
    }
  };
  const cancel = () => {
    refundShow.value = false;
    form.value = {
      refundType: 1,
      refundAmount: 0,
      isPick: false,
      remark: ''
    };
    refundDetail.value = {};
  };
  return {
    refundDetail,
    refundShow,
    form,
    open,
    onlyRefund,
    submit,
    cancel
  };
};
__sfc_main.components = Object.assign({
  goodsInfo
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .required::before {
    content: '*';
    position: absolute;
    left: -10px;
    top: 20%;
    color: #f56c6c;
  }
</style>
